import { IGroupImage } from '../interfaces/group-avatar.interface';

export class GroupAvatar {
    public src: string;
    id: string;

    constructor(image: IGroupImage) {
        this.src = image.thumb_url ? image.thumb_url : image.url;
        this.id = image.id ? image.id.toString() : null;
    }
}
